import { render } from "./Login.vue?vue&type=template&id=48c18852&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=48c18852&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48c18852"

export default script